import { render } from "./trailwindComponent.vue?vue&type=template&id=2db08372"
import script from "./trailwindComponent.vue?vue&type=script&lang=js"
export * from "./trailwindComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__